import React                            from "react";
import { Redirect }                     from "react-router-dom";
import AuthService                      from "./AuthService";
import AuthService_primero              from "./AuthService_primero";
import Container                        from "@material-ui/core/Container";
import Typography                       from "@material-ui/core/Typography";
import Box                              from "@material-ui/core/Box";
import Link                             from "@material-ui/core/Link";
import TextField                        from "@material-ui/core/TextField";
import Button                           from "@material-ui/core/Button";
import Grid                             from "@material-ui/core/Grid";
import MenuItem                         from "@material-ui/core/MenuItem";
import Select                           from "./components/Select";
import { withStyles }                   from "@material-ui/core/styles";
import { colores, globales, funciones } from "./global";
import { MuiThemeProvider }             from "@material-ui/core/styles";
import decode                           from 'jwt-decode';
import Request                          from "superagent";
import Dialog                           from "@material-ui/core/Dialog";
import DialogContent                    from "@material-ui/core/DialogContent";
import BarraBotones                     from "./components/Barra_menu";
import Tooltip                          from "@material-ui/core/Tooltip";
import PersonIcon                       from "@material-ui/icons/Security";
import Build                            from '@material-ui/icons/BuildRounded';
import QueryBuilder                     from '@material-ui/icons/QueryBuilderRounded';
import {  GoogleOAuthProvider  }        from  '@react-oauth/google' ;
import {GoogleLogin  }                  from "@react-oauth/google";
import Divider                          from "@material-ui/core/Divider";
import CircularProgress                 from "@material-ui/core/CircularProgress";
import Backdrop                         from "@material-ui/core/Backdrop";
import AppBar                           from "@material-ui/core/AppBar";
import Toolbar                          from "@material-ui/core/Toolbar";
import SvgIcon                          from '@material-ui/core/SvgIcon';
import FacebookIcon                     from "@material-ui/icons/Facebook";
import InstagramIcon                    from "@material-ui/icons/Instagram";
import IconButton                       from "@material-ui/core/IconButton";
import PersonOutlineOutlinedIcon        from "@material-ui/icons/PersonOutlineOutlined";
import LockOutlinedIcon                 from "@material-ui/icons/LockOutlined";
import Fab                              from "@material-ui/core/Fab";
import DialogTitle                      from "@material-ui/core/DialogTitle";
import DialogActions                    from "@material-ui/core/DialogActions";
import RoomOutlinedIcon                 from "@material-ui/icons/RoomOutlined";
import DraftsOutlinedIcon               from "@material-ui/icons/DraftsOutlined";
import YouTubeIcon                      from "@material-ui/icons/YouTube";
import                                      './CSS/Style_login.css';
import {theme}                          from './themeMui_login';

var movil =/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let currentUsuario = null;
let currentPassword = null;
//var unixTime = require('unix-time');
//var time = unixTime(new Date());  

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://siga.usap.edu/">
        Melioris
      </Link>{" "}
      {new Date().getFullYear()}
      {" - Honduras - Términos y Servicios"}
      {"."}
    </Typography>
  );
}

const useStyles = (theme) => ({});

export default withStyles(useStyles)(
  class Login extends React.Component {
    constructor() {
      super();
      this.Auth = new AuthService();
      this.Auth_primero = new AuthService_primero();
      this.state = {
        redirect: false,
        usuario: "",
        password: "",
        sucursales: [],
        selection: "",
        descrip_sucursal: [],
        datos: [],
        open: false,
        openModalPass: false,
        cuenta: "",
        openDialogPass: false,
        openDialoginternos: false,
        alertas: "",
        cuentaDecrpt: "",
        openBackDrop: false,
        showFields: true,// se cambio a true
        showError: false,
        loginGoogle: 1,
        consultaGoogle: false,
        altoSlide: 0,
        altoParaSlideLogin: 0,
        altoLabel: 0,
        altoToolbar: 0,
        altoBotones: 0,
        altoRedes: 0,
        gridWidth: 0,
        activeStep: 0,
        preActiveStep: 0,
        tokenGoo: ''
      };

      const botonesSucursal = [
        {icono: "Add",toolt: "Seleccionar Sucursal",nombre: "Seleccionar",escritura: true, onclick: this.handleClick_modal,display: "auto",},
        {icono: "Close",toolt: "Cancelar",nombre: "Cancelar",escritura: true,onclick: this.cerrarModal,color: "red",display: "auto",},
      ];
      const botonesPass = [
        {icono: "Add",toolt: "Enviar Correo",nombre: "Enviar Correo",escritura: true,onclick: this.clickEnviarCorreoPass,display: "auto",},
        {icono: "Close",toolt: "Cancelar",nombre: "Cancelar",escritura: true,onclick: this.cerrarModalPass,color: "red",display: "auto",},
      ];
      const botones_permisos = [
        {icono: "Like",toolt: "Entendido",nombre: "entendido",onclick: this.cerrarDialogPass,display: "auto",},
      ];
      const botones_internos = [
        {icono: "Close",toolt: "Cerrar",nombre: "Cerrar",onclick: this.cerrarDialoginternos,display: "auto",color: 'red',},
      ];

      this.botonesSucursal=botonesSucursal
      this.botonesPass=botonesPass
      this.botones_permisos=botones_permisos
      this.botones_internos=botones_internos
    } //FIN CONSTRUCTOR

     componentDidMount() {
     /* let _this = this;

      try {
        new Request.post(`${globales.ip}/tipoLogin`)
          .set("Content-Type", "application/json")
          .retry(0)
          //.timeout({ response: 15000, deadline: 60000 })
          .end((err, res) => {
            if (err) 
            {
              if (err.toString().substr(0, 16) === "Error: Forbidden") 
              {
                funciones.showToast("e", "Error forbidden");
                _this.setState({showError: true,});
                return;
              } 
              else if (err.toString() === "Error: Response timeout of 15000ms exceeded") 
              {
                funciones.showToast("e","Error en la comunicación con el servidor");
                _this.setState({showError: true,});
                return;
              }
              funciones.showToast("e", "Error de conexión");
            }

            const rows = JSON.parse([{VALOR: 0}]);

            if(rows[0].VALOR===null)
            {
              this.setState({loginGoogle: null,showFields: true,});
            }
            else
            if (rows.length > 0) {
              if (rows[0].VALOR === "0") {
                this.setState({loginGoogle: 0,showFields: true,});
              } else if (rows[0].VALOR === "1") {
                this.setState({loginGoogle: 1,showFields: true,});
              } else {
                funciones.showToast("e", "Error en la lectura del response");
              }
            }

          });
      } catch (ex) {
        funciones.showToast("e", "Error de conexión");
        _this.setState({ validado: true });
      }*/
    }

    handleClick_1 =  () => {
      let _this = this;
      _this.setState({ openBackDrop: true },  () => {
      if ((currentUsuario !== "" && currentPassword!=="") || (_this.state.usuario !== "" && _this.state.password !== "") ||_this.state.loginGoogle === 1) 
      {
          _this.Auth_primero.login(currentUsuario,currentPassword)
          .then( (res) => {
            if (res.mensaje !== "Authentication_Failed") {
              const tmp2 = res;
              if (tmp2.length === 1) 
              {
                _this.setState({selection: tmp2[0].ID_SUCURSAL,descrip_sucursal: tmp2[0].DESCRIPCION_SUCURSAL,tokenGoo: ''});
               
                _this.directo_sin_modal('');
              } 
              else if (tmp2.length > 0) 
              {
                this.setState({ sucursales: tmp2,tokenGoo: '', selection: [] });

                let Datos = _this.state.sucursales.map((datos, i) => {
                  return (
                    <MenuItem value={datos.ID_SUCURSAL} key={datos.DESCRIPCION_SUCURSAL}>
                      {datos.DESCRIPCION_SUCURSAL}
                    </MenuItem>
                  );
                });

                _this.setState({datos: Datos,});

                if (tmp2.length > 1) 
                {
                  this.setState({ openBackDrop: false }, () => {this.setState({ open: true });});
                } 
                else 
                {
                  funciones.showToast("e", "Error de conexión");
                  _this.setState({selection: tmp2[0].ID_SUCURSAL,descrip_sucursal: tmp2[0].DESCRIPCION_SUCURSAL,});

                  _this.Auth.login('',currentUsuario,currentPassword,_this.state.selection,_this.state.descrip_sucursal
                  ).then((res) => {
                    
                      if(res.token!=='INTERNO')
                      (async function () {
                        _this.setState({ redirect: true });
                      })();
                      else
                      (async function () {
                      _this.setState({ openDialoginternos: true,openBackDrop: false});
                      })();
                    })
                    .catch((err) => {
                      _this.setState({ openBackDrop: false});
                    });
                }
              }
            } 
            else 
            {
              _this.setState({ openBackDrop: false }, () => {
                funciones.showToast("w","Nombre de Usuario o Contraseña incorrecto");
              });
            }
          }).catch((err) => {
            _this.setState({ openBackDrop: false});
          });
        } else {
          _this.setState({ openBackDrop: false }, () => {
            funciones.showToast("e", "Ingrese usuario y/o contraseña");
          });
        }
      });
    };

    clicklogueocorreo=(tokenGoo)=>{
      let _this = this;
      _this.setState({ openBackDrop: true },  () => {
      if ((currentUsuario !== "" && currentPassword!=="") || (_this.state.usuario !== "" && _this.state.password !== "") ||_this.state.loginGoogle === 1) 
      {
          _this.Auth_primero.login(currentUsuario,currentPassword)
          .then( (res) => {

            if (res.mensaje !== "Authentication_Failed") {
              const tmp2 = res;
              if (tmp2.length === 1) 
              {
                _this.setState({selection: tmp2[0].ID_SUCURSAL,descrip_sucursal: tmp2[0].DESCRIPCION_SUCURSAL,tokenGoo:tokenGoo});
                _this.directo_sin_modal(tokenGoo);
              } 
              else if (tmp2.length > 0) 
              {
                this.setState({ sucursales: tmp2,tokenGoo:tokenGoo, selection: [] });

                let Datos = _this.state.sucursales.map((datos, i) => {
                  return (
                    <MenuItem value={datos.ID_SUCURSAL} key={datos.DESCRIPCION_SUCURSAL}>
                      {datos.DESCRIPCION_SUCURSAL}
                    </MenuItem>
                  );
                });

                _this.setState({datos: Datos,});

                if (tmp2.length > 1) 
                {
                  this.setState({ openBackDrop: false }, () => {this.setState({ open: true });});
                } 
                else 
                {
                  funciones.showToast("e", "Error de conexión");
                  _this.setState({selection: tmp2[0].ID_SUCURSAL,descrip_sucursal: tmp2[0].DESCRIPCION_SUCURSAL,});

                  _this.Auth.login(tokenGoo,currentUsuario,currentPassword,_this.state.selection,_this.state.descrip_sucursal
                  ).then((res) => {
                    
                      if(res.token!=='INTERNO')
                      (async function () {
                        _this.setState({ redirect: true });
                      })();
                      else
                      (async function () {
                      _this.setState({ openDialoginternos: true,openBackDrop: false});
                      })();
                    })
                    .catch((err) => {
                      _this.setState({ openBackDrop: false});
                    });
                }
              }
            } 
            else 
            {
              _this.setState({ openBackDrop: false }, () => {
                funciones.showToast("w","Nombre de usuario o contraseña incorrecto");
              });
            }
          }).catch((err) => {
            _this.setState({ openBackDrop: false});
          });
        } else {
          _this.setState({ openBackDrop: false }, () => {
            funciones.showToast("e", "Ingrese usuario y/o contraseña");
          });
        }
      });
    }

    clickOlvidastePass = async () => {
      let _this = this;
      _this.setState({ openModalPass: true });
    };

    directo_sin_modal = (tokenGoo) => {
      let _this = this;

      _this.setState({ openBackDrop: true }, () => {
      if (_this.state.selection.length !== 0 && _this.state.selection !== "") 
      {
        _this.Auth.login(tokenGoo,currentUsuario,currentPassword,_this.state.selection,_this.state.descrip_sucursal)
        .then((res) => {

          if(res.token==='Authentication_Failed'){
            funciones.showToast("w", "Error de autenticación");
              _this.setState({ openBackDrop: false });
              return;
          }

          if(res.token==='Not_information'){
              funciones.showToast("w", "Usuario sin acceso");
              _this.setState({ openBackDrop: false });
              return;
          }
        
          if(res.token!=='INTERNO')
            (async function () {
              _this.setState({ redirect: true });
            })();
          else
            (async function () 
            {
              _this.setState({ openDialoginternos: true,openBackDrop: false, open:false });
            })();
        })
        .catch((err) => {
            _this.setState({ openBackDrop: false }, () => {funciones.showToast("w", "Error de autenticación");});
          });
        } else {
          _this.setState({ openBackDrop: false }, () => {
            funciones.showToast("w", "Seleccione sucursal");
          });
        }
      });
    };

    handleClick_modal = () => {
      let _this = this;
      //backdrop DE SUCURSALES
      _this.setState({ openBackDrop: true }, () => {
      if (_this.state.selection.length !== 0 && _this.state.selection !== "") 
      {
        _this.Auth.login(this.state.tokenGoo,currentUsuario,currentPassword,_this.state.selection,_this.state.descrip_sucursal)
        .then((res) => {
        if(res.token==='Not_information'){
            funciones.showToast("w", "Usuario sin acceso");
            _this.setState({ openBackDrop: false });
            return;
        }
        
        if(res.token!=='INTERNO')
          (async function () {
            _this.setState({ redirect: true });
          })();
        else
          (async function () 
          {
            _this.setState({ openDialoginternos: true,openBackDrop: false, open:false });
          })();

        }).catch((err) => {
            _this.setState({ openBackDrop: false }, () => {funciones.showToast("e", "Error de conexión");});
          });
        } else {
          _this.setState({ openBackDrop: false }, () => {
            funciones.showToast("w", "Seleccione sucursal");
          });
        }
      });
    };

    handleChangeCuenta = (event) => {
      this.setState({ cuenta: event.target.value });
    };

    handleChange = (event) => {
      currentUsuario=event.target.value;
    };

    handleChange2 = (event) => {
      currentPassword=event.target.value;
    };

    handleChangeSelect = (event) => {
      var descrip_sucursal;
      this.state.datos.forEach(function getCheck(item2, index2) {
        if (item2.value === event.target.value) descrip_sucursal = item2.label;
      });
      this.setState({selection: event.target.value,descrip_sucursal: descrip_sucursal,});
    };
    cerrarModal = (event) => {
      this.setState({ open: false });
      localStorage.removeItem("id_token");
      localStorage.removeItem("usuario");
    };
    cerrarModalPass = (event) => {
      this.setState({ openModalPass: false });
    };
    cerrarDialogPass = (event) => {
      this.setState({ openDialogPass: false });
    };

    handleKeyPress = (event) => {
      if (event.key === "Enter") {
        this.handleClick_1();
      }
    };

    handleKeyPressPass = (event) => {
      if (event.key === "Enter") {
        this.clickEnviarCorreoPass();
      }
    };

    cerrarDialoginternos=()=>{this.setState({openDialoginternos:false,redirect:false})}

    responseGoogleError = (response) => {
      let _this = this;

      if (_this.state.loginGoogle === 1) {
        funciones.showToast('e',"Error en la comunicación con Google");
      }
    };

    
      /** FUNCION PARA VALIDAR EL RESPONSE DE GOOGLE **/
      responseGoogleSuccess = (response) => {
        let _this = this;

        _this.setState({ openBackDrop: true, consultaGoogle: true }, () => {

          const Token=decode(response.credential)
          let Email=Token.email
          let Hd=Token.hd
          let usuario=Email.replace('@'+Hd,'')

          if (("@" + Hd).toLowerCase() === globales.dominioCorreo) 
          {
            currentUsuario=usuario//arregloDeSubCadenas[0];
            _this.setState({openBackDrop: false,consultaGoogle: false,usuario: usuario,},
            ()=>{
                _this.clicklogueocorreo(response.credential);
            });
          } else {
            _this.setState({ openBackDrop: false, consultaGoogle: false },
              () => {
                funciones.showToast("e","@" +Hd+"; No es un correo USAP"
              );
              }
            );
          }
        });
      };

    render() {
      const { classes } = this.props;
      const { redirect } = this.state;
      const { activeStep } = this.state;

      //var element = document.getElementById('myframelogout')   
      /*if(element!==null)
      {
        setTimeout(() => {element.remove();}, 5000);
      }*/

      //this.getParamsUrl();
      if (redirect === true || (localStorage.getItem('id_token')!==null && localStorage.getItem('id_token')!=='Authentication_Failed' && localStorage.getItem('id_token')!=='Not_information' )) {
        return <Redirect to={{pathname:"/Principal",state:{from:'login'} }} />;
      } 
      else {
        //this.Auth.logout();
        localStorage.removeItem('id_token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('estado_menu');
	      localStorage.removeItem('Tabs_user');
      }

      return (
          <MuiThemeProvider theme={theme}>
            <div style={{background:movil?"none":"linear-gradient(162deg, rgba(255,255,255,1) 68%, rgba(0,67,139,0.46551120448179273) 88%, rgba(0,51,106,1) 100%)"}} 
            className="div_principal" >
              <Grid container  spacing={0} alignItems="center" className="grid-principal">
                  <AppBar id="altoToolbar" position="absolute" className={!movil?"appbar":"appbar-movil"}>
                    <Toolbar className={movil?"toolbar-movil":"toolbar"}>
                      <Button size={movil?"small":"large"} classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }} onClick={() =>window.open(globales.enlacesMenu.campusVirtual)} style={{ width: movil ? "50%" : "auto" }}>
                        Campus Virtual
                      </Button>
                      <Button size={movil?"small":"large"} classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }} onClick={() =>window.open(globales.enlacesMenu.admisiones)} style={{width: movil ? "50%" : "auto"}}>
                        {movil ? "Admisión" : "Solicitud de Admisión"}
                      </Button>
                      {!movil ? (
                        <Button size="large" onClick={() => window.open(globales.enlacesMenu.usap)} classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }}>
                          USAP
                        </Button>
                      ) : null}
                      {!movil ? (
                        <Button size="large" classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }} onClick={() =>window.open(globales.enlacesMenu.recorridoVirtual)}>
                          Instalaciones
                        </Button>
                      ) : null}
                      {!movil ? (
                        <Button size="large" classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }} onClick={() =>window.open(globales.enlacesMenu.sugerencias)}>
                          Sugerencias
                        </Button>
                      ) : null}
                      {!movil ? (
                        <Button size="large"classes={{ root: movil?'root-boton-toolbar-movil':'root-boton-toolbar' }} onClick={() =>window.open(globales.enlacesMenu.contactanos)}>
                          Contáctanos
                        </Button>
                      ) : null}
                    </Toolbar>
                  </AppBar>                               
                <Grid item xs={movil ? 12 : window.innerWidth < 850 ? 6 : 4} className="grid-middle-left" id="gridWidth">
                  <Container component="main"  className={'container'}>
                    <div id="loginMain" align="center" style={{width: "100%"}}>
                      <div align="center" >
                        <img src={"/Multimedia/USAPAzul.webp"} style={{width: movil?156:224, height: movil?65:95 }} alt={"USAP"}/>
                      </div>
                      {!this.state.showFields ?
                      <div id="cargaLogin" >
                      {
                        !this.state.showError ?
                        <div id="circle">
                          <CircularProgress color="inherit" />
                        </div>
                        :null
                      }
                      {
                        this.state.showError ?
                        <div id="cargarError">
                          Error de servidor
                        </div>
                        :null
                      }
                      </div>
                      :null
                      }

                      {this.state.showFields?
                      <div align='center' id="camposLogin" style={{width: '100%' }}>
                        {this.state.loginGoogle === 0 ?
                        <div align='center'>
                          <div align='center' style={{width: '60%'}}>
                          <Grid container spacing={0} alignItems="flex-end">
                            <Grid item xs={2}>
                              <PersonOutlineOutlinedIcon style={{ marginBottom: 5 }}/>
                            </Grid>
                            <Grid item xs={10}>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="usuario"
                                label="Usuario"
                                name="usuario"
                                defaultValue={currentUsuario}
                                autoFocus
                                onChange={this.handleChange}
                                onKeyPress={this.handleKeyPress}
                              />
                            </Grid>
                          </Grid>

                          <Grid container spacing={0} alignItems="flex-end">
                            <Grid item xs={2}>
                              <LockOutlinedIcon style={{ marginBottom: 5 }} />
                            </Grid>
                            <Grid item xs={10}>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="contraseña"
                                label="Contraseña"
                                type="password"
                                id="contraseña"
                                onChange={this.handleChange2}
                                onKeyPress={this.handleKeyPress}
                                defaultValue={currentPassword}
                              />
                            </Grid>
                          </Grid>
                          <br/>
                          <Fab variant="extended" size="small" color="primary"
                            style={{width: "100%",textTransform: "none",boxShadow: theme.shadows[0],backgroundColor: "rgb(3, 25, 48)",}}
                            onClick={this.handleClick_1}
                          >
                            Entrar
                          </Fab>
                          <br />
                          <br />
                          <Divider />
                          </div>
                          <br />
                          {true===false?
                          <Grid container>
                            <Grid item xs>
                              <Link onClick={this.clickOlvidastePass} href="#" variant="body2">
                                ¿Olvidaste la contraseña?
                              </Link>
                            </Grid>
                          </Grid>
                          :null
                          }
                        </div>
                        :null
                        }
                        <br/>
                        {
                        this.state.loginGoogle === 1 ?
                            <div align='center' style={{marginTop:10,marginBottom:30,padding:20,width:'60%'}}>
                              <GoogleOAuthProvider  clientId = {globales.claveApiGoogle} >
                                <GoogleLogin
                                  shape='circle' type='standard' locale="ES" theme="filled_black"
                                  width='100%' size='large' text="signin_with"
                                  onSuccess={this.responseGoogleSuccess}
                                  onError={this.responseGoogleError}
                                  useOneTap={false}
                                  auto_select={false}
                                  select_account={true}
                                />
                            </GoogleOAuthProvider>
                           </div>
                        :null
                        }
                        {
                          this.state.loginGoogle === null ?<div style={{marginTop: 30,marginBottom: 30,color:colores.naranja,fontWeight:'bold'}}><div style={{marginBottom:10}}><QueryBuilder fontSize="large"/><Build fontSize="large" /></div>La plataforma esta en Mantenimiento</div>:null
                        }
                        <div align='center' style={{width: '100%',marginTop:movil&&this.state.loginGoogle === 1?100:'auto'}}>
                        <Tooltip title="Facebook">
                          <IconButton onClick={() =>window.open(globales.redesSociales.facebook)} size="small" className="boton-redes">
                            <FacebookIcon style={{ fontSize: "30" }}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="X">
                          <IconButton onClick={() =>window.open(globales.redesSociales.twitter)} size="small" className="boton-redes">
                           <SvgIcon>
                              <svg  height="1em" viewBox="0 0 512 512" > 
                              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                              </svg>
                            </SvgIcon>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Youtube">
                          <IconButton onClick={() =>window.open(globales.redesSociales.youtube)} size="small" className="boton-redes">
                            <YouTubeIcon style={{ fontSize: "30" }}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Instagram">
                          <IconButton onClick={() =>window.open(globales.redesSociales.instagram)} size="small" className="boton-redes">
                            <InstagramIcon style={{fontSize:"30",borderRadius: 7,}}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="TikTok">
                          <IconButton onClick={() =>window.open(globales.redesSociales.tiktok)} size="small" className="boton-redes">
                          <SvgIcon>
                            <svg height="1em"  viewBox="0 0 512 512" >
                            <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/>
                            </svg>
                          </SvgIcon>
                          </IconButton>
                        </Tooltip>
                        </div>
                        <br/>
                      </div>
                      :null
                      }
                    </div>
                  </Container>
                  {!movil?
                  <Box mt={1} className="Box-Copyright">
                      <Copyright />
                  </Box>
                  :null}
                </Grid>
                {movil?null:
                <Grid item xs={movil ? 8 : window.innerWidth < 850 ? 6 : 8} className={"grid-middle-right"}>
                  <div align='right' style={{width:'100%',paddingRight: 25}}>
                    <img src={"/Multimedia/ImagenesLogin/Imagenlogin.webp"} alt={'imagenlogin'} className="img"/>
                    </div>
                    </Grid>
                  }
              </Grid>
            </div>
            <Dialog
              open={this.state.open}
              disableEnforceFocus
              disableAutoFocus
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              classes={{paper: classes.Dialog}}
              fullScreen={movil ? true : false}
              maxWidth="xs"
              fullWidth={true}
            >
              <DialogTitle id="confirmation-dialog-title">
                Seleccione una Sucursal
              </DialogTitle>
              <DialogContent style={{ padding: 15, textAlign: "center" }}>
                <Grid container spacing={0} alignItems="center" style={{ textAlign: "center" }}>
                  <RoomOutlinedIcon style={{ color: "gray", paddingLeft: movil ? 10 : 11 }} fontSize="large"/>
                  <Grid item xs={10}>
                    <Select
                      Label="Sucursal"
                      Datos={this.state.datos}
                      Selected={this.state.selection}
                      onChange={this.handleChangeSelect}
                      Multiple={false}
                      Style={'select-sucursal'}
                      ShowItemNone={true}
                      LabelItemNone=""
                      ValueItemNone=""
                      AutoFocus={false}
                      Outlined={true}
                      SelectClass={{ height: movil ? "auto" : 36 }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <BarraBotones botones={this.botonesSucursal} />
              </DialogActions>
            </Dialog>

            <Dialog
              open={this.state.openModalPass}
              disableEnforceFocus
              disableAutoFocus
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              classes={{ paper: classes.Dialog }}
              fullScreen={movil ? true : false}
              maxWidth="xs"
              fullWidth={true}
            >
              <DialogTitle id="confirmation-dialog-title">
                Ingrese su Número de Cuenta
              </DialogTitle>
              <DialogContent style={{ padding: 15, textAlign: "center" }}>
                <Grid container spacing={0} alignItems="center" style={{ textAlign: "center" }}>
                  <DraftsOutlinedIcon style={{color: "gray",paddingLeft: movil ? 10 : 11,marginRight: 3,}} fontSize="large"/>
                  <Grid item xs={10}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="cuentaEstudiante"
                      label="Cuenta Estudiante:"
                      name="cuentaEstudiante"
                      autoFocus
                      onChange={this.handleChangeCuenta}
                      margin="dense"
                      style={{ marginLeft: 5 }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <BarraBotones botones={this.botonesPass} />
              </DialogActions>
            </Dialog>

            <Dialog
              open={this.state.openDialogPass}
              disableEnforceFocus
              disableAutoFocus
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              fullWidth={false}
              classes={{ paper: classes.Dialog }}
            >
              <DialogContent>
                <Typography align="center">{this.state.alertas}</Typography>
                <br />
              </DialogContent>
              <BarraBotones botones={this.botones_permisos} />
            </Dialog>
            <Dialog open={this.state.openDialoginternos} disableEnforceFocus disableAutoFocus fullWidth={false} maxWidth='xs' classes={{ paper: classes.Dialog }}>
              <DialogTitle id="confirmation-dialog-internos">
                Información
              </DialogTitle>
              <DialogContent style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:10}}>
                <PersonIcon style={{color:colores.azul,marginRight:15}}/>
                <Typography align="center">{'Su usuario solo es para uso interno.'}</Typography>
                <br />
              </DialogContent>
              <BarraBotones botones={this.botones_internos} />
            </Dialog>
            <Backdrop className={'backdrop'} open={this.state.openBackDrop}>
              <CircularProgress color="inherit" />
              <span style={{ marginTop: "10px" }}>{"Cargando..."}</span>
            </Backdrop>
          </MuiThemeProvider>
      );
    }
  }
);